export default "__VITE_ASSET__Zn9urks0__"